import LeftComponentsContainer from './left_components_container';

export default LeftComponentsContainer;
